export default function StatusCards({ orders, flaggedCount, activeCard, onCardClick }) {
  const today = new Date().toDateString();

  const counts = {
    needsAttention: flaggedCount || 0,
    inTransit: 0,
    deliveredToday: 0,
    awaitingShipment: 0,
  };

  for (const order of orders) {
    const status = (order.status || '').toLowerCase();

    if (status === 'shipped' || status === 'in_transit') {
      counts.inTransit++;
    }

    if (
      status === 'delivered' &&
      order.delivered_at &&
      new Date(order.delivered_at).toDateString() === today
    ) {
      counts.deliveredToday++;
    }

    if (order.send_authorized && !order.tracking) {
      counts.awaitingShipment++;
    }
  }

  const cards = [
    {
      key: 'needsAttention',
      label: 'Needs Attention',
      value: counts.needsAttention,
      icon: (
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
        </svg>
      ),
      color: 'text-amber-600',
      bg: 'bg-amber-50',
      ring: 'ring-amber-400',
    },
    {
      key: 'inTransit',
      label: 'In Transit',
      value: counts.inTransit,
      icon: (
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 00-.879-2.121l-3.44-3.44a2.999 2.999 0 00-2.121-.879H14.25M2.25 9h7.5M2.25 12h4.5" />
        </svg>
      ),
      color: 'text-blue-600',
      bg: 'bg-blue-50',
      ring: 'ring-blue-400',
    },
    {
      key: 'deliveredToday',
      label: 'Delivered Today',
      value: counts.deliveredToday,
      icon: (
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      color: 'text-emerald-600',
      bg: 'bg-emerald-50',
      ring: 'ring-emerald-400',
    },
    {
      key: 'awaitingShipment',
      label: 'Awaiting Shipment',
      value: counts.awaitingShipment,
      icon: (
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      color: 'text-gray-500',
      bg: 'bg-gray-50',
      ring: 'ring-gray-400',
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {cards.map((card) => {
        const isActive = activeCard === card.key;
        return (
          <button
            key={card.key}
            onClick={() => onCardClick(card.key)}
            className={`bg-white rounded-xl border shadow-sm px-5 py-4 flex items-start justify-between text-left transition-all cursor-pointer ${
              isActive
                ? `border-transparent ring-2 ${card.ring}`
                : 'border-gray-200 hover:border-gray-300'
            }`}
          >
            <div>
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-1">{card.label}</p>
              <p className="text-3xl font-bold text-gray-900 tabular-nums">{card.value}</p>
            </div>
            <div className={`${card.bg} ${card.color} p-2 rounded-lg`}>
              {card.icon}
            </div>
          </button>
        );
      })}
    </div>
  );
}
